import { useEffect, useState } from "react";

import { useRouter } from "next/router";

import UserProgress from "shared/components/organisms/UserProgress";

import { AuthorsContent, ColInfoUser } from "./styles";

const Authors = ({ author }) => {
  const router = useRouter();

  const avatarUrl = author?.photo;
  const displayName = author?.display_name || author?.full_name;

  let bio = author && author.biography;
  if (bio?.length > 110) bio = `${bio.slice(0, 110)}...`;

  const [dragging, setDragging] = useState(false);

  useEffect(() => {
    const setDragStateToFalse = () => setDragging(false);
    const setDragStateToTrue = () => setDragging(true);

    document.addEventListener("mousedown", setDragStateToFalse);
    document.addEventListener("mousemove", setDragStateToTrue);

    return () => {
      document.removeEventListener("mousedown", setDragStateToFalse);
      document.removeEventListener("mousemove", setDragStateToTrue);
    };
  }, []);

  const handleClick = (e) => {
    const tagIsClickable =
      e.target.tagName !== "H1" &&
      e.target.tagName !== "circle" &&
      e.target.tagName !== "DIV" &&
      e.target.tagName !== "SPAN";

    if (!dragging && !tagIsClickable) {
      router.push(`/user/${author.username}`);
    } else {
      e.stopPropagation();
      e.preventDefault();
    }
  };

  return (
    <AuthorsContent>
      <ColInfoUser
        onClick={(e) => handleClick(e)}
        xs={24}
        md={24}
        lg={24}
        xl={9}
        xxl={8}
      >
        <UserProgress userSession={author} image={avatarUrl} />

        <h1>{displayName}</h1>

        <div className="author-bio">
          <span>{bio}</span>
        </div>
      </ColInfoUser>
    </AuthorsContent>
  );
};

export default Authors;
